import React from 'react';
import { Box, Typography } from '@mui/material';
import { LandingLayoutSVG } from '../assets/LandingLayoutSVG';

const Home = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                width: '100%',
                paddingY: 4,
                gap: 8,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1,
                }}
            >
                <Typography
                    variant="h1"
                    textAlign="center"
                    fontSize={72}
                    color="primary"
                    fontWeight={600}
                >
                    Score de Crédito
                </Typography>
                <Typography
                    variant="h2"
                    textAlign="center"
                    fontSize={36}
                    color="secondary"
                    fontWeight={500}
                >
                    Consulta tu BC Score
                </Typography>
            </Box>
            <LandingLayoutSVG width={500} />
        </Box>
    );
};

export default Home;
